export const COOKIE_MESSAGE =
  'En poursuivant votre navigation, vous acceptez l’utilisation des cookies afin de nous permettre d’améliorer votre expérience utilisateur.';
export const COOKIE_TRUE =
  'LIq5lMHzsA3Xb7RanYiXkcCuUpX+hKlJD0VKSCTps5V2zzOXfKJrnJiaWNPLVR8ruyEkZOYoGGV0CCuV4uayPg==';
export const COOKIE_FALSE =
  'AJTo62n4d1E55DSJt5PCSBANPh/enUj/YUqCzT43UVN/7Qd7FEo8T1r35DzzD5my/I2RXhOogn92zuvS6fX5zw==';
